module.exports = __webpack_public_path__ + "static/media/tshirt.8015d25d.svg";